
import { defineComponent } from 'vue'
import BlurButton from '@/components/BlurButton.vue'
import Slider from '@/components/Slider.vue'
import Box from '@/components/Box.vue'
import LinkArrow from '@/components/LinkArrow.vue'

export default defineComponent({
  components: {
    'tp-blur-button': BlurButton,
    'tp-box': Box,
    'tp-slider': Slider,
    'tp-link-arrow': LinkArrow
  },
  data: function () {
    return {}
  },
  methods: {
    goToGame() {
      this.$store.dispatch('setGameStatus', true)
      this.$router.push('/game')
    },
  },
  mounted() {
    this.$store.dispatch('setGameStatus', false)
    this.$store.dispatch('setWinStatus', false)
    this.$store.dispatch('setLoseStatus', false)
  },
})
